import { Component } from '@angular/core';

@Component({
  selector: 'td-wb-card-subtitle',
  template: '<ng-content />',
  styleUrls: ['card-subtitle.component.scss']
})
export class CardSubtitleComponent {
}
